<template>
  <div>
      <el-image style="width: 150px; height: 80px;" fit="scale-down"
                :src="require('/src/assets/image/logo.png')" ></el-image>
    <div style="overflow: auto;height: 90vh" >
      <el-menu class="menu" router v-loading="$store.state.systemMenu.loading"
               active-text-color="white"
               :default-active="activeIndex">
        <son-menu :data="$store.state.systemMenu.list"/>
      </el-menu>
    </div>
  </div>
</template>

<script>
import SonMenu from './SonMenu.vue'
export default {
  components: {SonMenu},
  name: "Aside",
  data() {
    return {
      activeIndex: this.$route.path,
    }
  },
  methods:{
  },
  created() {
  }
}
</script>
<style>
/* 修改滚动条的宽度 */
::-webkit-scrollbar {
  width: 6px; /* 纵向滚动条的宽度 */
  height: 12px; /* 横向滚动条的高度 */
}

/* 滚动条轨道部分 */
::-webkit-scrollbar-track {
  background-color: #f5f5f5;
  border-radius: 10px;
}

/* 滚动条滑块部分 */
::-webkit-scrollbar-thumb {
  background-color: #d2d2d2;
  border-radius: 10px;
}

/* 鼠标悬停在滑块上时 */
::-webkit-scrollbar-thumb:hover {
  background-color: #cbcbcb;
}
</style>
<style scoped>
.menu{
  padding: 0 20px 20px 20px;
  border: none;
}
.el-header {
  background-color: #B3C0D1;
  color: #333;
  line-height: 60px;
}
::v-deep .el-menu-item:hover, ::v-deep .el-submenu__title:hover {
  background-color: #ffeded !important; /* 设置悬停背景色 */
  border-radius: 12px;
}

.el-menu-item.is-active {
  background-color: #ff4d4f !important;
  border-radius: 12px;
}
.el-aside {
  color: #333;
}

</style>